import axios from "axios";
import Cookies from "js-cookie";

export interface ApiServiceInterface {
  get(endpoint: string): Promise<any>;
  post(endpoint: string, data: any): Promise<any>;
  put(endpoint: string, data: any): Promise<any>;
  delete(endpoint: string): Promise<any>;
  auth(token: string): Promise<any>;
}

export class ApiService implements ApiServiceInterface {
  private baseUrl;
  private token;
  private multipart;

  constructor(baseUrl) {
    this.baseUrl = baseUrl;

    this.token = Cookies.get("jwtToken")
      ? {
        headers: {
          Authorization: `Bearer ${Cookies.get("jwtToken")}`,
        },
      }
      : {};

    this.multipart = Cookies.get("jwtToken")
      ? {
        headers: {
          Authorization: `Bearer ${Cookies.get("jwtToken")}`,
          'Content-Type': 'multipart/form-data',
        },
      }
      : {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };
  }

  async get(endpoint) {
    try {
      const response = await axios.get(`${this.baseUrl}${endpoint}`, this.token);
      return response.data;
    } catch (error) {
      // Handle error
      throw error;
    }
  }

  async post(endpoint, data, multipart = false) {
    try {
      const headers = multipart ? this.multipart : this.token;
      const response = await axios.post(`${this.baseUrl}${endpoint}`, data, headers);
      return response.data;
    } catch (error) {
      // Handle error
      throw error;
    }
  }

  async put(endpoint, data, multipart = false) {
    try {
      const headers = multipart ? this.multipart : this.token;
      const response = await axios.put(`${this.baseUrl}${endpoint}`, data, headers);
      return response.data;
    } catch (error) {
      // Handle error
      throw error;
    }
  }

  async delete(endpoint) {
    try {
      const response = await axios.delete(`${this.baseUrl}${endpoint}`, this.token);
      return response.data;
    } catch (error) {
      // Handle error
      throw error;
    }
  }

  async auth(token) {
    try {
      const response = await axios.post(`${this.baseUrl}/login`, null, {
        headers: { Authorization: `Basic ${token}` },
      });
      return response.data;
    } catch (error) {
      // Handle error
      throw error;
    }
  }

  //   async customRequest(method, endpoint, data) {
  //     try {
  //       const response = await axios.request({
  //         method,
  //         url: `${this.baseUrl}${endpoint}`,
  //         data,
  //       });
  //       return response.data;
  //     } catch (error) {
  //       // Handle error
  //       throw error;
  //     }
  //   }
}
